var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pdfView",staticClass:"comp-ym-pdfimage"},_vm._l((_vm.pages),function(page,index){return _c('div',{key:index,staticClass:"pdf-page"},[_c('canvas'),_c('div',{staticClass:"text-layer"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }